/* Guard native Vision add-to-cart buttons and forms for Shopify product type E-könyv.
   Checkout-level enforcement requires a Shopify Cart and Checkout Validation Function. */
(() => {
  'use strict';
  if (window.EmpyreumEbookQuantityGuard) return;
  window.EmpyreumEbookQuantityGuard = true;

  const bypass = new WeakSet();
  const pending = new Set();
  const duplicateText = 'Ebből az e-könyvből már van egy a kosaradban. Legfeljebb 1 példány rendelhető.';

  function showMessage(element, message) {
    const cartPage = element.closest('emp-cart-page-consistent');
    if (cartPage && typeof cartPage.message === 'function') {
      cartPage.message(message, true);
      return;
    }
    const container = element.closest('product-form, product-card, product-card-small, [data-ecart-add-form]');
    if (!container) return;
    const host = container.querySelector('.product-card-info, .product-card-small--info') || container;
    let status = host.querySelector(':scope > [data-empyreum-ebook-feedback]');
    if (!status) {
      status = document.createElement('p');
      status.className = 'empyreum-ebook-feedback';
      status.dataset.empyreumEbookFeedback = '';
      status.setAttribute('role','alert');
      host.append(status);
    }
    status.hidden = false;
    status.textContent = message;
  }

  function cartURL() {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return (root.endsWith('/') ? root : root + '/') + 'cart.js';
  }

  async function allowOne(productId, element, replay) {
    if (pending.has(productId)) {
      showMessage(element, 'Az e-könyv hozzáadása már folyamatban van.');
      return;
    }
    pending.add(productId);
    let replayed = false;
    try {
      const response = await fetch(cartURL(), {
        credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json'}
      });
      if (!response.ok) throw new Error('Cart check failed');
      const cart = await response.json();
      if (!Array.isArray(cart.items)) throw new Error('Missing cart items');
      if (cart.items.some(item => String(item.product_id) === productId && Number(item.quantity) > 0)) {
        showMessage(element, duplicateText);
        return;
      }

      // Replay only after the up-to-date cart confirms this product is absent.
      replay();
      replayed = true;
      let onAdded;
      const timer = setTimeout(() => {
        document.removeEventListener('cart:item-added',onAdded);
        pending.delete(productId);
      }, 12000);
      onAdded = event => {
        const added = event.detail && event.detail.product;
        if (String((added && (added.product_id || added.productId)) || '') !== productId) return;
        clearTimeout(timer);
        document.removeEventListener('cart:item-added',onAdded);
        pending.delete(productId);
      };
      document.addEventListener('cart:item-added',onAdded);
    } catch (error) {
      showMessage(element, 'Nem sikerült ellenőrizni az e-könyv darabszámát. Kérjük, próbáld újra.');
    } finally {
      if (!replayed) pending.delete(productId);
    }
  }

  document.addEventListener('click', event => {
    const el = event.target instanceof Element ? event.target : event.target.parentElement;
    const button = el && el.closest(
      'button.product-card--add-to-cart-button-simple, product-card-small button.product-card-small--add-to-cart-button'
    );
    if (!button) return;
    const root = button.closest('[data-empyreum-ebook-id]');
    if (!root) return;
    if (bypass.has(button)) {bypass.delete(button);return;}
    event.preventDefault();
    event.stopImmediatePropagation();
    if (button.disabled) return;
    allowOne(root.dataset.empyreumEbookId,button,() => {
      bypass.add(button);
      button.click();
    });
  },true);

  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const root = form.matches('[data-empyreum-ebook-id]') ? form :
      form.closest('product-form[data-empyreum-ebook-id]');
    if (!root) return;
    if (bypass.has(form)) {bypass.delete(form);return;}
    event.preventDefault();
    event.stopImmediatePropagation();
    const submitter = event.submitter;
    allowOne(root.dataset.empyreumEbookId,form,() => {
      const field = form.elements.namedItem('quantity') ||
        document.querySelector('input[name="quantity"][form="' + form.id + '"]');
      if (field && field.tagName === 'INPUT') field.value = '1';
      bypass.add(form);
      if (submitter && submitter.form === form) form.requestSubmit(submitter);
      else form.requestSubmit();
    });
  },true);
})();
